module.exports = __webpack_public_path__ + "static/media/galerija_2017 (27).057e920e.jpg";